import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class Attachment extends ApplicationRecord {
  static jsonapiType = "attachments";

  @Attr({ persist: false }) createdAt: string;

  @Attr() description: string;

  @Attr() filename: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;
}

export default Attachment;
